import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntMonthSelectorComponent} from "./int-month-selector.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntMonthSelectorComponent
  ],
  exports: [
    IntMonthSelectorComponent
  ]
})
export class IntMonthSelectorModule {}
